import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Input from "./Input";
import Radios from "./Radios";
import { close, open } from "../redux/popupSlice";

import * as APIS from "../utils/service";

const JOIN_LIMITS = [50, 100, 200, 500];

// 소모임 신청 화면
const GatheringApplication = ({ setInnerStep, setStep, detailInfo }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { configdata } = useSelector(s => s.configReducer);

    const [bigCategory, setBigCategory] = useState(configdata?.consts?.communityCategory1[0]?.idx); // 대 카테고리
    const [smallCategory, setSmallCategory] = useState(configdata?.consts?.communityCategory2[0]?.idx); // 소 카테고리
    const [gatherName, setGatherName] = useState(""); // 소모임명
    const [purpose, setPurpose] = useState(""); // 목적
    const [joinType, setJoinType] = useState(1); // 가입방식 1=바로가입 2=승인 후 가입
    const [pNumber, setPNumber] = useState(JOIN_LIMITS[0]); // 최대인원
    const [agree, setAgree] = useState(false); // 약관동의

    const messagePopup = (message) => {
        dispatch(open({
            component: message,
            button: "확인",
            alert: false,
            onPress: () => {
                dispatch(close());
            }
        }));
    }
    const submitJoin = () => {
        if (bigCategory === 0) {
            messagePopup("대 카테고리를 선택해주세요.")
            return;
        }
        if (smallCategory === 0) {
            messagePopup("소 카테고리를 선택해주세요.")
            return;
        }
        if (gatherName === "") {
            messagePopup("소모임명을 입력해주세요.")
            return;
        }
        if (purpose > 50) {
            messagePopup("목적을 50자 이상 입력해주세요.")
            return;
        }
        if (!agree) {
            messagePopup("이용약관에 동의해주세요.")
            return;
        }

        let sender = {
            cate1: bigCategory,
            cate2: smallCategory,
            title: gatherName,
            desc: purpose,
            join_type: joinType,
            max_count: pNumber,
        };

        if (detailInfo) {
            sender.idx = detailInfo?.idx
        }

        dispatch(
            open({
                component: "등록하시겠습니까?",
                title: "커뮤니티 등록",
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                // wideOne: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/insert', sender).then(({ data }) => {
                        setInnerStep(1);
                        setStep(1);

                        dispatch(
                            open({
                                component: "신청이 완료되었습니다.",
                                title: "알림",
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                }
                            })
                        );
                    }).catch(({ response }) => {
                        const { data } = response;
                        dispatch(
                            open({
                                component: data?.msg || "잠시후 다시 시도해주세요.",
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    };

    useEffect(() => {
        if (detailInfo) {
            // 재신청일 경우
            setBigCategory(detailInfo?.cate1 * 1)
            setSmallCategory(detailInfo?.cate2 * 1)
            setGatherName(detailInfo?.title)
            setPurpose(detailInfo?.desc)
            setJoinType(detailInfo?.join_type)
            setPNumber(detailInfo?.max_count)
        }
    }, [detailInfo])

    return (
        <div className="community_modal_white_wrap">
            {detailInfo?.status * 1 === 9 && <p style={{width:"100%",fontWeight:800,color:"#6164a5"}}>
                * 소모임 개설 신청은 동시에 1건만 가능합니다.<br />
                * 반려 된 소모임 신청건이 있으므로 내용을 수정하고 재신청하시기 바랍니다.
            </p>}
            <p>
                모두의매물 소모임 운영방침은 대한민국 법령을 절대 준수합니다.
                모두의매물 소모임을 이용하여 중개 행위 방해·단합 등 법령에서
                금지하는 행위를 하는 경우 해당 소모임은 별도 통보 없이 즉시 폐쇄
                될 수 있으며, 이로인해 발생한 민·형사상의 책임은 온전히
                모두의매물 소모임 운영자에게 있음을 알립니다 <br />
                ＊관계법령 : 공인중개사법 제33조(금지행위), 형법
                제307조(명예훼손) 등
            </p>
            <div className="new_gathering_wrap">
                <div className="community_modal_line_wrap">
                    <p
                        style={{
                            fontSize: "14px",
                            width: "100px",
                        }}
                    >
                        카테고리
                    </p>
                    <div className="community_modal_line">
                        <div className="custom-select">
                            <select
                                value={bigCategory}
                                onChange={(e) => {
                                    setBigCategory(Number(e.target.value));
                                }}
                            >
                                {configdata?.consts?.communityCategory1?.map(v => {
                                    return <option value={v?.idx}>
                                        {v?.title}
                                    </option>
                                })}
                            </select>
                        </div>
                        <div className="custom-select">
                            <select
                                value={smallCategory}
                                onChange={(e) => {
                                    setSmallCategory(Number(e.target.value));
                                }}
                            >
                                {configdata?.consts?.communityCategory2?.filter(v => v?.category1 == bigCategory)?.map(v => {
                                    return <option value={v?.idx}>
                                        {v?.title}
                                    </option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="community_modal_line_wrap">
                    <p style={{
                        fontSize: "14px",
                        width: "100px",
                    }}>
                        소모임명
                    </p>
                    <div className="community_modal_line">
                        <Input
                            className="inputs"
                            type="text"
                            value={gatherName}
                            setValue={setGatherName}
                            placeholder="직접입력"
                        />
                    </div>
                </div>
                <div
                    className="community_modal_line_wrap"
                    style={{ alignItems: "flex-start" }}
                >
                    <p style={{
                        fontSize: "14px",
                        width: "100px",
                    }}>
                        목적
                    </p>
                    <div className="community_modal_line">
                        <textarea
                            value={purpose}
                            onChange={(e) => setPurpose(e.target.value)}
                            placeholder="최소 50글자 이상 작성해주세요."
                        />
                    </div>
                </div>
                <div
                    className="community_modal_line_wrap"
                    style={{ alignItems: "flex-start" }}
                >
                    <p
                        style={{
                            fontSize: "14px",
                            width: "100px",
                        }}
                    >
                        가입방식
                    </p>
                    <div className="community_modal_line">
                        <Radios
                            linetype={"radioimg"}
                            values={joinType}
                            setvalues={setJoinType}
                            namevalue={configdata?.consts?.communityJoinType?.map(v => ({ names: v?.title, values: v?.idx }))}
                            // namevalue={[
                            //     {
                            //         names: "가입 신청 시 바로 가입",
                            //         values: 1,
                            //     },
                            //     {
                            //         names: "운영진 승인 후 가입",
                            //         values: 2,
                            //     },
                            // ]}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                            flexDirection={"column"}
                            fontDispaly={"contents"}
                            FlexWrap={"nowrap"}
                            gap={"10px"}
                        />
                    </div>
                </div>

                <div className="community_modal_line_wrap">
                    <p style={{
                        fontSize: "14px",
                        width: "100px",
                    }} >
                        최대인원
                    </p>
                    <div className="community_modal_line">
                        <div className="custom-select">
                            <select
                                value={pNumber}
                                onChange={(e) => {
                                    setPNumber(parseInt(e.target.value));
                                }}
                            >
                                {JOIN_LIMITS.map(v => {
                                    return <option value={v}>{v}명</option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <input
                    type="checkbox"
                    id="agreebtn"
                    className="chkbox_design"
                    onChange={() => setAgree(!agree)}
                    checked={agree}
                />
                <label htmlFor="agreebtn">
                    <span onClick={(e) => {
                        e.preventDefault();
                        let sender = {
                            type: 7
                        }
                        APIS.postData('/term', sender).then(({ data }) => {
                            //console.log(data);
                            const PopComponents = () => {
                                return (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: data }}
                                        className='termContetns'
                                    />

                                );
                            }
                            dispatch(
                                open({
                                    component: <PopComponents />,
                                    title: "소모임 이용약관",
                                    titleviewer: true,
                                    alert: false,
                                    alertStyle: {
                                        width: 800
                                    }
                                })
                            );
                        }).catch((e) => {
                        }).finally(() => {
                        });
                    }}>모두의매물 소모임 이용약관</span>에 동의합니다.
                </label>
            </div>
            <div className="bottom_btn_wrap">
                <button className="register" onClick={() => submitJoin()}>
                    {detailInfo ? "재신청하기" : "신청하기"}
                </button>
                <button className="cancel" onClick={() => setStep(1)}>
                    닫기
                </button>
            </div>
        </div>
    );
};
export default GatheringApplication;
